import React, {useCallback, useEffect, useRef, useState} from "react";
import {SplitButton} from "primereact/splitbutton";
import {showError} from "../../../../api/notification/ToastManager";
import {exportMarketNodeDataAsZip} from "../../../../api/file/download-service";
import {DataCollectionType} from "../../../../enums/DataCollectionType";

const ExportButton = ({
                          dcName,
                          dcId,
                          isDisplayed,
                          disabled = false,
                          messageOnDisable = "",
                          listOfMarketNodes = [],
                          dataCollectionType
                      }) => {
    const btn = useRef(null);
    const [isVisible, setIsVisible] = useState(isDisplayed);
    const [isInProgress, setIsInProgress] = useState(false);
    useEffect(() => {
        setIsVisible(isDisplayed);
    }, [isVisible])
    const exportMarketNodeAsZip = (dataType) => {

        exportData(listOfMarketNodes, dcName, dcId, dataType)
    }

    const exportData = (marketNodes, dcName, dcId, dataType) => {
        setIsInProgress(true);
        exportMarketNodeDataAsZip({
            dataCollection: {name: dcName, id: dcId},
            marketNodes: marketNodes
        }, dataType)
            .then(_ => setIsInProgress(false))
            .catch(_ => {
                showError("Export failed", "An error occurs when exporting " + dataType + " data, Please try again later.")
            });


    }

    const items = dataCollectionType === DataCollectionType.PEMMDB ? [
        {
            label: 'Excel',
            icon: 'pi pi-file-excel',
            command: () => {
                exportMarketNodeAsZip("excel");
            }
        },
        {
            label: 'RDF',
            icon: 'pi pi-file-pdf',
            command: () => {
                exportMarketNodeAsZip("rdf");
            }
        }
    ] : null;

    const show = useCallback((e) => {
        if (dataCollectionType === DataCollectionType.IGM) {
            exportMarketNodeAsZip("xml");
        } else {
            btn.current.show(e);
        }
    }, [dataCollectionType, dcId])

    const buttonTemplate = useCallback(() => {
        return <i className={"pi pi-file-export"}
                  style={{color: '#487c84'}}/>
    }, [])

    if (isVisible) {
        return (
            !isInProgress ?
                <SplitButton
                    ref={btn}
                    tooltip={`${disabled ? messageOnDisable : "Export Data"}`}
                    tooltipOptions={{position: 'top', showOnDisabled: true}}
                    className="p-button-rounded-sm p-button-text align-items-center"
                    buttonTemplate={buttonTemplate}
                    style={{height: '1.6rem', width: '3.2rem'}}
                    model={items}
                    onClick={show}
                    menuButtonClassName={"hidden"}
                    disabled={disabled}
                /> :
                <SplitButton
                    ref={btn}
                    className="p-button-rounded-sm p-button-text align-items-center"
                    icon={"pi pi-spin pi-spinner"}
                    style={{height: '1.6rem', width: '3.2rem'}}
                    menuButtonClassName={"hidden"}
                    disabled={true}
                />
        )
    } else return null;

}

export default ExportButton;
